import React from 'react';
import PropTypes from 'prop-types';
import {autobind} from 'core-decorators';
import {connect} from 'react-redux';
import CSSModules from 'react-css-modules';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import Input from 'components/common/material-form/Input';
import RaisedButton from 'components/common/material/RaisedButton';
import {reduxForm, Field, formValueSelector} from 'redux-form';
import {ValidationsUtils} from 'utils/validationUtils';
import styles from './auth.scss';

const selector = formValueSelector('resetPassword');

function validate(values, props) {
  // intl comes from @injectIntl which has to be called before @reduxForm in order to work
  const {intl: {formatMessage}} = props;
  const errorKeys = {};

  ValidationsUtils.required('password', values, errorKeys);
  ValidationsUtils.required('verifyPassword', values, errorKeys);
  ValidationsUtils.passwordRules('password', values, errorKeys);
  ValidationsUtils.verifyPassword('verifyPassword', 'password', values, errorKeys);

  const errors = Object.keys(errorKeys).reduce((mappedErrors, errorField) => {
    if (errorKeys[errorField]) {
      mappedErrors[errorField] = formatMessage({id: errorKeys[errorField]});
    }
    return mappedErrors;
  }, {});

  return errors;
}

@injectIntl
@reduxForm({
  form: 'resetPassword',
  validate
})
@connect(
  state => ({
    password: selector(state, 'password'),
    verifyPassword: selector(state, 'passwordRepeat'),
  })
)
@CSSModules(styles, {allowMultiple: true})
export class CreateNewPasswordForm extends React.Component {

  static propTypes = {
    intl: intlShape,
    submitCallback: PropTypes.func.isRequired,
    failReason: PropTypes.string,
    password: PropTypes.string,
    verifyPassword: PropTypes.string,
    invalid: PropTypes.bool.isRequired,
    isFail: PropTypes.bool,
  };

  constructor(props) {
    super(props);
  }

  @autobind
  handleSubmit() {
    const {password} = this.props;
    this.props.submitCallback(password);
  }

  // renderFail() {
  //   const failValues = {
  //     loginLink: staticComponents.loginLink,
  //     resetLink: staticComponents.resetLink,
  //   };
  //
  //   return (
  //     <div styleName="content">
  //       <div styleName="title" data-at="failureTitle"><FormattedMessage id="auth.title.resetFailed"/></div>
  //       <br/>
  //       <div styleName="subtitle" data-at="failureSubitle">
  //         <FormattedMessage id="auth.message.resetFailed" values={failValues}/>
  //       </div>
  //     </div>
  //   );
  // }

  render() {
    const {intl: {formatMessage}} = this.props;

    return (

      <div styleName="content">
        <div styleName="partition title"><FormattedMessage id="createNewPassword.title"/></div>
        <div styleName="partition">
          <div styleName="subtitle">
            <FormattedMessage id="createNewPassword.instructions"/>
          </div>
        </div>
        {
          this.props.isFail &&
          <div data-at={'genericError'} styleName="noAccount">
            <FormattedMessage id="common.technicalError"/>
          </div>
        }
        <div>
          <Field data-at="passwordInput" type="password" name="password" component={Input} label={formatMessage({id: 'auth.newPassword'})} fullWidth={true}/>
        </div>
        <div>
          <Field data-at="verifyPasswordInput" type="password" name="verifyPassword" component={Input} label={formatMessage({id: 'auth.retypePassword'})} fullWidth={true}/>
        </div>
        <br/>
        <div>
          <RaisedButton onClick={this.handleSubmit}
                        disabled={this.props.invalid}
                        fullWidth={true}
                        primary={true}
                        data-at="saveNewPassword"
                        label={formatMessage({id: 'createNewPassword.button.save'})}/>
        </div>
        <br/>
      </div>
    );

  }
}



// WEBPACK FOOTER //
// ./src/auth/CreateNewPasswordForm.js